import { httpRequest } from "@services/http"

export type AudienceNetworkPolicyPayload = {
  network: string
  percent: number
  margin?: number
  daily_spend_cap?: number | null
  bid?: number | null
  name?: string
}

export class CommandUpsertAudienceNetworkPolicy {
  async run(launchId: number, adGroupId: number, data: AudienceNetworkPolicyPayload): Promise<void> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/launches/${launchId}/ad-groups/${adGroupId}/policies/budget/`
    await httpRequest(url, { method: "POST", body: data })
  }
}
